import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ProductTileSimple from '../product/ProductTileSimple';
import ProductTilesListcontext from '@stone/scripts/contexts/ProductTilesListContext';
import useProductsList from '@stone/hooks/useProductsList';
const ShopByCategoryModal = (props) => {
    var _a;
    const { activeCategory } = props;
    // ANCHOR - HOOKS --------------------------------------------------------------------
    const [isAnimate, setIsAnimate] = useState(false);
    const { t } = useTranslation();
    const { products, getProducts, loading, resetProducts } = useProductsList(props.itemListName, (_a = props.activeCategory) === null || _a === void 0 ? void 0 : _a.limit);
    const isOpen = useMemo(() => !!(props === null || props === void 0 ? void 0 : props.activeCategory), [props.activeCategory]);
    const listContext = useMemo(() => {
        let context = {};
        context.analyticsData = {
            item_list_name: props.itemListName,
        };
        return context;
    }, [props.itemListName]);
    // ANCHOR - FUNCTIONS --------------------------------------------------------------------
    const onModalClose = (e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setIsAnimate(false);
        props.closeModal();
    };
    // ANCHOR - USE EFFECT --------------------------------------------------------------------
    useEffect(() => {
        if (isOpen && activeCategory) {
            getProducts(activeCategory);
        }
        return () => resetProducts();
    }, [activeCategory, isOpen]);
    // ANCHOR - RENDER --------------------------------------------------------------------
    return (React.createElement(Modal, { closeTimeoutMS: 600, onAfterOpen: () => setIsAnimate(true), isOpen: isOpen, className: classNames('shop-by-category__modal', { open: isAnimate }), overlayClassName: "shop-by-category__modal-overlay", onRequestClose: () => onModalClose(), contentLabel: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title },
        React.createElement("div", { className: "shop-by-category__modal-body " },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "shop-by-category__modal-header" },
                    React.createElement("h2", { className: "font__title" }, activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.title),
                    React.createElement("button", { type: "button", "aria-label": t('button.close'), className: "modal__close", onClick: (e) => onModalClose(e) })),
                React.createElement("p", { className: "shop-by-category__modal-description", dangerouslySetInnerHTML: { __html: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.description } }),
                !!(products === null || products === void 0 ? void 0 : products.length) && !loading && (React.createElement(ProductTilesListcontext.Provider, { value: listContext },
                    React.createElement("div", { role: "region" },
                        React.createElement("h3", { className: "font__title grid-container-title" }, activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.list_title),
                        React.createElement("ul", { className: "grid-container" }, products.map((el, i) => {
                            var _a;
                            return (React.createElement("li", { key: `${el.uuid}_${i}`, "aria-labelledby": `${el.uuid}_link` },
                                React.createElement(ProductTileSimple, { product: el, type: "RECS", customImage: (_a = el.assetOverride) === null || _a === void 0 ? void 0 : _a.car })));
                        }))))))),
        React.createElement("a", { href: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.link_url, className: "button button--primary button-view-category" },
            React.createElement("span", null, activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.link_label))));
};
export default ShopByCategoryModal;
